module.exports = require("html-react-parser");